import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		PartnertypPzn: [],
		KategOzn: [],
		StatId: [],
		Titul: [],
	},
	edit: {
		CisloOrient: null as number | null,
		CisloOrientPismeno: null as string | null,
		CisloPopisne: null as number | null,
		DicNr: null as string | null,
		EMailAdresa: null as string | null,
		EditDat: null as string | null,
		EditPracId: null as number | null,
		EditPracIdText: null as string | null,
		FaxNr: null as string | null,
		IcoNr: null as string | null,
		Jmeno: null as string | null,
		KategOzn: null as number | null,
		Kns: null as number | null,
		Memo: null as string | null,
		Obec: null as string | null,
		ObecCast: null as string | null,
		OsobniCis: null as string | null,
		Oznam: null as string | null,
		PartnertypPzn: null as number | null,
		PartnertypPznText: null as string | null,
		PersoncardId: null as string | null,
		PscNr: null as string | null,
		StatId: null as number | null,
		TelfmaNr: null as string | null,
		TelmobNr: null as string | null,
		TelprivNr: null as string | null,
		Text: null as string | null,
		Titul: null as string | null,
		Ulice: null as string | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		VstupProvId: null as number | null,
		VstupPracIdText: null as string | null,
		ZakaznikId: null as string | null,
		ZakaznikkonId: null as number | null,
		ZamestzarazeniId: null as number | null,
		Operations: null as number | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
	},
});
